import { ApiEndpoints, reqPostNew, ReqResponse } from "../../../config/apiClient"
import { getUrlSearchParams } from "../../urlParams"

export async function getDocumentosReqPost(id_pasta: number):Promise<ReqResponse> {
    const dados = {
        id_pasta: id_pasta === 0 ? null : id_pasta,
    }
    const api = await reqPostNew(ApiEndpoints.documentosPasta, dados)
    return api
}

export function getPageUrlIdPasta():number | null {
    const urlDados = getUrlSearchParams()
    if (urlDados.get("pasta") === "null" || urlDados.get("pasta") === null) {
        return null
    }
    const id_pasta = Number(urlDados.get("pasta"))
    return id_pasta
}